/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_Portfolio_BadgeInputs */

const en_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your portfolio`)
};

const de_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Portfolio`)
};

const pt_br2_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu portfólio`)
};

const tr_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyün`)
};

const zh_cn2_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的投资组合`)
};

const zh_hk2_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的投資組合`)
};

const ko_kr2_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 포트폴리오`)
};

const ru_ru2_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш портфель`)
};

const es_419_onboarding_v1_fund_portfolio_badge = /** @type {(inputs: Onboarding_V1_Fund_Portfolio_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu portafolio`)
};

/**
* | output |
* | --- |
* | "Your portfolio" |
*
* @param {Onboarding_V1_Fund_Portfolio_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_portfolio_badge = /** @type {((inputs?: Onboarding_V1_Fund_Portfolio_BadgeInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_Portfolio_BadgeInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "de") return de_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_portfolio_badge(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_portfolio_badge(inputs)
	return es_419_onboarding_v1_fund_portfolio_badge(inputs)
});